import React from 'react'

export const ErrorPage = () => {
  return (
    <div className='error'>
      <p>Oops! Something went wrong.</p>
    </div>
  );
}
